import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { FeatureFlags } from '~src/ts/FeatureFlags';
import { ISessionInfo } from '~src/ts/ServerApi/types/ISessionInfo';

import { Telemetry } from '../../../commonInfra/services/Telemetry';
import { IntlUserSettings, TelemetryEvents } from '../TelemetryEvents';

export type StartersTelemertyOptions = Telemetry;

export const intlLoginTelemetryEvent = (sessionInfo: ISessionInfo) => {
    if (FeatureFlags.intlTelemetry) {
        Telemetry.sendEvent<IntlUserSettings>({
            type: TelemetryEvents.IntlUserSettings,
            Product: 'server_client',
            Action: 'login',
            User_Role: sessionInfo.site.role,
            Language: sessionInfo.user.language,
            Locale: sessionInfo.user.locale,
            Browser_Language: navigator.language,
            Browser_Type: navigator.userAgent,
        });
    }
};

export const intlSettingsLangChangeTelemetryEvent = (language: string) => {
    if (FeatureFlags.intlTelemetry) {
        const user_role = getSessionManagementServiceInstance().sessionSiteRole();
        Telemetry.sendEvent<IntlUserSettings>({
            type: TelemetryEvents.IntlUserSettings,
            Product: 'server_client',
            Action: 'language_update',
            User_Role: user_role,
            Language: language,
            Locale: '',
            Browser_Language: navigator.language,
            Browser_Type: navigator.userAgent,
        });
    }
};

export const intlSettingsLocaleChangeTelemetryEvent = (locale: string) => {
    if (FeatureFlags.intlTelemetry) {
        const user_role = getSessionManagementServiceInstance().sessionSiteRole();
        Telemetry.sendEvent<IntlUserSettings>({
            type: TelemetryEvents.IntlUserSettings,
            Product: 'server_client',
            Action: 'locale_update',
            User_Role: user_role,
            Language: '',
            Locale: locale,
            Browser_Language: navigator.language,
            Browser_Type: navigator.userAgent,
        });
    }
};